import React, { useState } from 'react';
import { Logo } from './Logo';
import { LegalModal } from './LegalModal';
type LegalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [legal, setLegal] = useState<LegalType>(null);
  return <footer className="bg-[#0D2B6E] pt-[60px] pb-[40px] px-6" data-id="element-105">
      <div className="max-w-6xl mx-auto" data-id="element-106">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-10" data-id="element-107">
          {/* Column 1 - Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-108">
            <Logo className="w-[70px] h-[70px] mb-4" data-id="element-109" />
            <span className="font-playfair text-white text-[20px] mb-2" data-id="element-110">
              Lorena Pérez
            </span>
            <p className="font-cormorant italic text-champagne-gold text-[16px] leading-[1.8] mb-4" data-id="element-111">
              Despertar cuerpos.
              <br data-id="element-112" />
              Restaurar confianza.
              <br data-id="element-113" />
              Transformar vidas.
            </p>
            <p className="font-montserrat text-white/50 text-[13px] leading-relaxed" data-id="element-114">
              54 años | 25 años con Herbalife
              <br data-id="element-115" />
              Fundadora RenuevaTE_90 &<br data-id="element-116" />
              Saludable sin ser Esclavo
            </p>
          </div>

          {/* Column 2 - Navigation */}
          <div className="flex flex-col items-center md:items-start" data-id="element-117">
            <h4 className="font-montserrat font-semibold text-champagne-gold text-[12px] tracking-widest uppercase mb-6" data-id="element-118">
              Explorar
            </h4>
            <ul className="space-y-3 font-montserrat text-[14px] text-white/70 text-center md:text-left" data-id="element-119">
              <li data-id="element-120">
                <a href="#" className="hover:text-champagne-gold transition-colors duration-200" data-id="element-121">
                  Inicio
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="hover:text-champagne-gold transition-colors duration-200" data-id="element-123">
                  Sobre Lorena
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-champagne-gold transition-colors duration-200" data-id="element-125">
                  Programa RenuevaTE_90
                </a>
              </li>
              <li data-id="element-126">
                <a href="#formulario" className="hover:text-champagne-gold transition-colors duration-200" data-id="element-127">
                  Comparte Tu Historia
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-champagne-gold transition-colors duration-200" data-id="element-129">
                  Comunidad
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="hover:text-champagne-gold transition-colors duration-200" data-id="element-131">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Social */}
          <div className="flex flex-col items-center md:items-start" data-id="element-132">
            <h4 className="font-montserrat font-semibold text-champagne-gold text-[12px] tracking-widest uppercase mb-6" data-id="element-133">
              Conectate
            </h4>
            <ul className="space-y-3 font-montserrat text-[14px] text-white/70 mb-6 text-center md:text-left" data-id="element-134">
              <li data-id="element-135">
                <a href="https://www.instagram.com/saludable_sin_ser_esclavo/" target="_blank" rel="noopener noreferrer" className="hover:text-champagne-gold transition-colors duration-200 flex items-center justify-center md:justify-start gap-2" data-id="element-136">
                  📸 Instagram: @saludable_sin_ser_esclavo
                </a>
              </li>
              <li data-id="element-137">
                <a href="https://wa.me/message/TXNOM773UTEKG1" target="_blank" rel="noopener noreferrer" className="hover:text-champagne-gold transition-colors duration-200 flex items-center justify-center md:justify-start gap-2" data-id="element-138">
                  📱 WhatsApp: Saludable Sin Ser Esclavo
                </a>
              </li>
              <li data-id="element-139">
                <a href="https://www.tiktok.com/@saludable_bylorenaperez" target="_blank" rel="noopener noreferrer" className="hover:text-champagne-gold transition-colors duration-200 flex items-center justify-center md:justify-start gap-2" data-id="element-140">
                  ▶️ TikTok: @saludable_bylorenaperez
                </a>
              </li>
              <li data-id="element-141">
                <a href="mailto:saludablesinseresclavo@gmail.com" className="hover:text-champagne-gold transition-colors duration-200 flex items-center justify-center md:justify-start gap-2" data-id="element-142">
                  📧 saludablesinseresclavo@gmail.com
                </a>
              </li>
              <li data-id="element-143">
                <a href="https://saludablebylorenaperez.com/" target="_blank" rel="noopener noreferrer" className="hover:text-champagne-gold transition-colors duration-200 flex items-center justify-center md:justify-start gap-2" data-id="element-144">
                  🌐 saludablebylorenaperez.com
                </a>
              </li>
            </ul>
            <p className="font-montserrat text-white/40 text-[12px] text-center md:text-left max-w-[250px]" data-id="element-145">
              Comunidad activa de mujeres 40+ hispanohablantes en USA y
              Latinoamérica
            </p>
          </div>
        </div>

        <div className="w-full h-[1px] bg-champagne-gold/30 my-10" data-id="element-146"></div>

        <div className="text-center font-montserrat font-light text-white/30 text-[12px] leading-relaxed" data-id="element-147">
          <p data-id="element-148">
            © 2026 RenuevaTE_90 | Lorena Pérez. Todos los derechos reservados.
          </p>
          <p data-id="element-149">
            Esta página es solo para fines informativos y de comunidad. No
            reemplaza asesoría médica profesional.
          </p>
          <p data-id="element-150">Los resultados pueden variar de persona a persona.</p>

          <div className="flex items-center justify-center gap-4 mt-4" data-id="element-151">
            <button onClick={() => setLegal('privacy')} className="text-white/50 hover:text-champagne-gold transition-colors duration-200 underline-offset-2 hover:underline" data-id="element-152">
              Política de Privacidad
            </button>
            <span className="text-white/20" aria-hidden="true" data-id="element-153">
              •
            </span>
            <button onClick={() => setLegal('terms')} className="text-white/50 hover:text-champagne-gold transition-colors duration-200 underline-offset-2 hover:underline" data-id="element-154">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </div>

      <LegalModal type={legal} onClose={() => setLegal(null)} data-id="element-155" />
    </footer>;
}